import { Routes } from '@angular/router';
import { TodayComponent } from './features/today/today.component';
import { SettingsComponent } from './features/settings/settings.component';
import { ActivitiesComponent } from './features/activities/activities.component';
import { LoginComponent } from './features/auth/login.component';
import { authGuard } from './core/auth/auth.guard';
import { AllocationDetailComponent } from './features/today/allocation-detail/allocation-detail.component';
import { FocusComponent } from './features/focus/focus.component';
import { TaskDetailComponent } from './features/today/task-detail/task-detail.component';
import { HabitDetailComponent } from './features/today/habit-detail/habit-detail.component';
import { GroupPageComponent } from './features/today/group-page/group-page.component';

/**
 * Defines the routes for the Angular application, mapping URL paths to their corresponding components.
 * The 'today', 'activities', and 'settings' routes are protected by the authGuard, which ensures
 * that only authenticated users can access them. The default route redirects to 'today'.
 *
 * @author sadatmalik
 */
export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'today', component: TodayComponent, canActivate: [authGuard] },
  { path: 'today/group', redirectTo: 'today', pathMatch: 'full' },
  { path: 'today/group/:ordinal', component: GroupPageComponent, canActivate: [authGuard] },
  { path: 'today/allocation/:activityTypeId', component: AllocationDetailComponent, canActivate: [authGuard] },
  { path: 'today/allocation/:activityTypeId/task/:taskId', component: TaskDetailComponent, canActivate: [authGuard] },
  { path: 'today/habit/:activityTypeId', component: HabitDetailComponent, canActivate: [authGuard] },
  { path: 'today/habit/:activityTypeId/task/:taskId', component: TaskDetailComponent, canActivate: [authGuard] },
  { path: 'focus', component: FocusComponent, canActivate: [authGuard] },
  { path: 'activities', component: ActivitiesComponent, canActivate: [authGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [authGuard] },
  { path: '', redirectTo: 'today', pathMatch: 'full' },
];
